import { render } from "./Travel.vue?vue&type=template&id=42ed217b"
import script from "./Travel.vue?vue&type=script&lang=ts"
export * from "./Travel.vue?vue&type=script&lang=ts"

import "./Travel.vue?vue&type=style&index=0&id=42ed217b&lang=scss"
script.render = render

export default script